"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = require("react-emotion");
var _typography = require("../../atoms/typography");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
var _css5;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Image = function Image(props) {
  return _react.default.createElement("img", _extends({
    alt: "Feature"
  }, props));
};
var Title = function Title(_ref) {
  var _css2;
  var children = _ref.children;
  return _react.default.createElement(_typography.H3, {
    className: (0, _emotion.css)((_css2 = {
      fontSize: '1.2rem',
      lineHeight: '1.7rem',
      fontWeight: 600
    }, _css2[(0, _mediaQueries.default)('md')] = {
      fontSize: '1.125rem'
    }, _css2))
  }, children);
};
var Description = function Description(_ref2) {
  var _css4;
  var children = _ref2.children;
  return _react.default.createElement("p", {
    className: (0, _emotion.css)((_css4 = {
      fontSize: '1.025rem',
      maxWidth: 300,
      margin: '15px auto'
    }, _css4[(0, _mediaQueries.default)('md')] = {
      fontSize: '0.875rem'
    }, _css4))
  }, children);
};
var feat = /*#__PURE__*/
(0, _reactEmotion.css)((_css5 = {
  textAlign: 'center'
}, _css5[(0, _mediaQueries.default)('lg')] = {
  margin: 30
}, _css5.img = {
  width: 200,
  height: 165,
  objectFit: 'contain'
}, _css5));
var Feature = /*#__PURE__*/
function (_Component) {
  function Feature() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Feature.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      style = _this$props.style;
    return _react.default.createElement("div", {
      className: (0, _reactEmotion.cx)(feat, className),
      style: style
    }, children);
  };
  _inheritsLoose(Feature, _Component);
  return Feature;
}(_react.Component);
_defineProperty(Feature, "Image", Image);
_defineProperty(Feature, "Title", Title);
_defineProperty(Feature, "Description", Description);
Title.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
Description.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])
};
Feature.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  style: _propTypes.object
};
var _default = Feature;
exports.default = _default;